import { render, staticRenderFns } from "./TractGroupDetailDialog.vue?vue&type=template&id=07748451&"
import script from "./TractGroupDetailDialog.vue?vue&type=script&lang=js&"
export * from "./TractGroupDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports